export const CONTENT_SLIDES_2 = [
  {
    "id": "bb9bc952-dc77-4df3-bd04-3f45af199d52",
    "image": "slide5.jpg",
    "alt_image": "image slide 5",
    "text_html": `
        <h1 class="text-uppercase text-center">des offres exceptionnels</h1>
        <p class="text-center">Découvrir les meilleurs de ce Weekend</p>
    `
  },
  {
    "id": "723d0212-947d-4c32-832a-39a46de8dee1",
    "image": "slide4.jpg",
    "alt_image": "image slide 4",
    "text_html": `
        <h1 class="text-uppercase text-center">des offres exceptionnels</h1>
        <p class="text-center">Découvrir les meilleurs de ce Weekend</p>
    `
  },
  {
    "id": "504d768a-f4a3-4c9c-be8f-e326ac9dbfbe",
    "image": "slide3.jpg",
    "alt_image": "image slide 3",
    "text_html": `
        <h1 class="text-uppercase text-center">des offres exceptionnels</h1>
        <p class="text-center">Découvrir les meilleurs de ce Weekend</p>
    `
  },
  {
    "id": "027f6b55-2ea2-425e-a2ce-1c37f11996e8",
    "image": "slide2.jpg",
    "alt_image": "image slide 2",
    "text_html": `
        <h1 class="text-uppercase text-center">des offres exceptionnels</h1>
        <p class="text-center">Découvrir les meilleurs de ce Weekend</p>
    `
  },
  {
    "id": "5d379c16-d729-4894-8341-c8c843d4ef65",
    "image": "slide1.jpg",
    "alt_image": "image slide 1",
    "text_html": `
        <h1 class="text-uppercase text-center">des offres exceptionnels</h1>
        <p class="text-center">Découvrir les meilleurs de ce Weekend</p>
    `
  },
]



// WEBPACK FOOTER //
// ./src/data/content_slides_2.js